const NoPage = () => {
    return <h1 style={{color: 'white', fontSize: '2.6rem'}}>404 Page not found</h1>;
  };
  
  export default NoPage;